import React from "react";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

function AddCountryModal({
  isLoadingAddNewCountry,
  isAddCountryModal,
  formik,
  onClickOfCancelButton,
}) {
  return (
    <>
      <Modal
        show={isAddCountryModal}
        onHide={onClickOfCancelButton}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        closeButton
      >
        <Modal.Header closeButton>
          <Modal.Title> {`Add New Country`}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
            <div className="row">
              <div className="col-md-12 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Country`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`Country`}
                  name="name"
                  {...formik.getFieldProps("name")}
                />
                {formik.touched.name && formik.errors.name ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.name}
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-4">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Country Code - (ISO 3166 two-character code)`}
                </h5>
                <input
                  type="text"
                  className="form-control form-control-solid form-control-solid-brand h-40px"
                  placeholder={`Country code i.e 'US'`}
                  name="country_code"
                  {...formik.getFieldProps("country_code")}
                />
                {formik.touched.country_code && formik.errors.country_code ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.country_code}
                  </div>
                ) : null}
              </div>

              <div className="col-md-12 mb-4 d-none">
                <h5 className="text-secondary fs-14 font-weight-normal text-left">
                  {`Select Status`}
                </h5>
                <select
                  className="form-control form-control-solid form-control-solid-brand h-40px is-valid-select"
                  name="status"
                  {...formik.getFieldProps("status")}
                >
                  <option value="1">{`Active`}</option>
                  <option value="0">{`Deactive`}</option>
                </select>
                {formik.touched.status && formik.errors.status ? (
                  <div className="invalid-feedback display-block">
                    {formik.errors.status}
                  </div>
                ) : null}
              </div>
            </div>
            <ButtonToolbar className="d-flex justify-content-end button-wrap mb-8 mt-8">
              <Button
                variant="btn btn-success mr-3"
                type="submit"
                disabled={formik.isSubmitting}
              >
                {`Add`}
                {isLoadingAddNewCountry && (
                  <span className=" mr-3 ml-3 spinner spinner-white"></span>
                )}
              </Button>
              <Button
                type="reset"
                variant="btn btn-light-dark"
                onClick={onClickOfCancelButton}
              >
                {`Cancel`}
              </Button>
            </ButtonToolbar>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default AddCountryModal;
